export const setFontSize = (container, ratio) => {
  const containerDim = container.getBoundingClientRect();
  container.style.fontSize = `${containerDim.height / ratio}px`;
};
